import {initialState} from "../initialState";
import {
    ADD_BLE_AVAILABLE, ADD_TCP_AVAILABLE,
    BLE_SEARCH_BEGAN,
    BLE_SEARCH_END,
    BLE_SEARCH_ERROR,
    TCP_SEARCH_BEGAN, TCP_SEARCH_END, TCP_SEARCH_ERROR
} from "../actionTypes/connection";


const connectionReducer = (state = initialState.connection, action) => {
    switch (action.type) {
        case BLE_SEARCH_BEGAN:
            return {
                ...state,
                bleSearching: true,
                bleError: null,
                bleAvailable: []
            }
        case ADD_BLE_AVAILABLE:
            return {
                ...state,
                bleAvailable: [...state.bleAvailable, action.payload]
            }
        case BLE_SEARCH_END:
            return {
                ...state,
                bleSearching: false
            }
        case BLE_SEARCH_ERROR:
            return {
                ...state,
                bleSearching: false,
                bleError: action.payload
            }

        case TCP_SEARCH_BEGAN:
            return {
                ...state,
                tcpSearching: true,
                tcpError: null,
                tcpAvailable: []
            }
        case ADD_TCP_AVAILABLE:
            return {
                ...state,
                tcpAvailable: [...state.tcpAvailable, action.payload]
            }
        case TCP_SEARCH_END:
            return {
                ...state,
                tcpSearching: false
            }
        case TCP_SEARCH_ERROR:
            return {
                ...state,
                tcpSearching: false,
                tcpError: action.payload
            }

        default:
            return state
    }
}

export default connectionReducer


// SELECTORS

export const getBleAvailableSelector = state => state.connection.bleAvailable
export const getTcpAvailableSelector = state => state.connection.tcpAvailable

export const getBleIsSearchingSelector = state => state.connection.bleSearching
export const getTcpIsSearchingSelector = state => state.connection.tcpSearching

export const getBleErrorSelector = state => state.connection.bleError
export const getTcpErrorSelector = state => state.connection.tcpError